module.exports = __webpack_public_path__ + "assets/img/raku.f229de00.svg";